/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Relative/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Avatar from 'DesignSystem/Avatar/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaChoice from 'DesignSystem/TysiaChoice/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaIconLocationOn from 'DesignSystem/Svgs/TysiaIconLocationOn/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Relative({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Postal/NewAddress/Content/Related/Content/Relative",
  onChange,
  presignedUrl
  
}) {
let relativeContactMethodIdValueData = fromData.useDataValue({ viewPath,
context: 'relative',
path: 'contact_method_id',
})
let newAddressContactMethodIdChangeData = fromData.useDataChange({ viewPath,
context: 'new_address',
path: 'contact_method_id',
})
let relativeContactMethodIdValueData1 = fromData.useDataValue({ viewPath,
context: 'relative',
path: 'contact_method_id',
})
let newAddressContactMethodIdValueData = fromData.useDataValue({ viewPath,
context: 'new_address',
path: 'contact_method_id',
})
let aggregateData = fromAggregate.equals(relativeContactMethodIdValueData1, newAddressContactMethodIdValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let relativePersonValueData = fromData.useDataFormat({ viewPath,
context: 'relative',
path: 'person',
format: fromFormat.initials,
})
let relativePersonValueData1 = fromData.useDataFormat({ viewPath,
context: 'relative',
path: 'person',
format: fromFormat.personName,
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let relativeTypeValueData = fromData.useDataFormat({ viewPath,
context: 'relative',
path: 'type',
format: fromFormat.capitalize,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let relativeAddressValueData = fromData.useDataFormat({ viewPath,
context: 'relative',
path: 'address',
format: fromFormat.format_address,
})
  return (<React.Fragment
>
<TysiaChoice
  viewPath={`${viewPath}/TysiaChoice`}
 width="60%"
 type="secondary"
 data="relative.contact_method_id"
 id={relativeContactMethodIdValueData}
 data="new_address.contact_method_id"
 onClick={newAddressContactMethodIdChangeData}
 data="relative.contact_method_id"
 data="new_address.contact_method_id"
 aggregate="/Data/aggregate.js equals"
 selected={aggregateData}
>
{childProps => (
<div
  data-testid="Relative.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-ZzmQ4b': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-2-ZzmQ4b': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-3-ZzmQ4b': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-4-ZzmQ4b': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Relative.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
 marginRight={dtSpaceXs}
 profile_url={presignedUrl}
 data="relative.person"
 format="/Data/format.js initials"
 initials={relativePersonValueData}
/>
<div
  data-testid="Relative.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Relative.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 color={dtColorsNeutral900}
 data="relative.person"
 format="/Data/format.js personName"
 text={relativePersonValueData1}
/>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 marginLeft={dtSpaceS}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="relative.type"
 format="/Data/format.js capitalize"
 text={relativeTypeValueData}
/>
)}
</TysiaTag>
</div>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 cursor="default"
 type="secondary"
 marginRight={dtSpaceXxs}
 marginTop={dtSpaceXxs}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconLocationOn
{...childProps}
  viewPath={`${viewPath}/TysiaIconLocationOn`}
 fill={dtColorsBlack}
/>
)}
</TysiaButtonIcon>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="relative.address"
 format="/Data/format.js format_address"
 text={relativeAddressValueData}
/>
</React.Fragment>
)}
</TysiaButton>
</div>
</div>
</div>
)}
</TysiaChoice>
{children}
</React.Fragment>)
}